import { Flight } from "../url";
import HttpService from "@/common/ApiService";
import configuration from "@/../public/urlConfig.json";
import vue from "vue";
const http = new HttpService(vue.prototype.$config.tourBaseAddress);
const factory = () => ({
    departureDate: null,
    returnDate: null,
    adultQuantity: null,
    childQuantity: null,
    infantQuantity: null
});

export default {
    namespaced: true,
    state: factory(),
    mutations: {
        SetRequest(state, params) {
            Object.assign(state, params);
        },

        ResetState(state) {
            Object.assign(state, factory());
        }
    },
    getters: {
        GetRequest(state) {
            return {
                departureDate: state.departureDate,
                returnDate: state.returnDate,
                adultQuantity: state.adultQuantity,
                childQuantity: state.childQuantity,
                infantQuantity: state.infantQuantity
            };
        },

        GetTotalPassengers(state) {
            return {
                adults: state.adultQuantity,
                children: state.childQuantity,
                infants: state.infantQuantity
            };
        }
    },
    actions: {
     
        async AvailableFlights(context, params) {
            const response = await http.Post(Flight.AVILABLE_URL, params);

            return response.data.data;
        },

        async InitialReserve(context, params) {
            const response = await http.Post(Flight.INITIAL_RESERVE_URL, params);

            return response.data;
        },

        ResetState(context) {
            context.commit("ResetState");
        },

        StoreRequest(context, params) {
            context.commit("SetRequest", params);
        }
    }
}